import React from "react";
import ReferralSettings from "./ReferralSettings";
import ReferralReminders from "./ReferralReminders";
import AutomationSettings from "./AutomationSettings";
import TriggerManagement from "./TriggerManagement";

const AutomationTab = ({
  // Referral Settings
  autoAcceptAWSReferrals,
  setAutoAcceptAWSReferrals,
  // Automation Settings
  autoSyncOpportunity,
  setAutoSyncOpportunity,
  automatedOpportunitySharing,
  setAutomatedOpportunitySharing,
  // Triggers
  triggers,
  handleCreateTrigger,
  handleEditTrigger,
  handleDeactivateTrigger,
  handleDeleteTrigger,
}) => {
  return (
    <div className="automation-alerts-content">
      <ReferralSettings
        autoAcceptAWSReferrals={autoAcceptAWSReferrals}
        setAutoAcceptAWSReferrals={setAutoAcceptAWSReferrals}
      />

      <ReferralReminders />

      <AutomationSettings
        autoSyncOpportunity={autoSyncOpportunity}
        setAutoSyncOpportunity={setAutoSyncOpportunity}
        automatedOpportunitySharing={automatedOpportunitySharing}
        setAutomatedOpportunitySharing={setAutomatedOpportunitySharing}
      />

      <TriggerManagement
        triggers={triggers}
        onCreateTrigger={handleCreateTrigger}
        onEditTrigger={handleEditTrigger}
        onDeactivateTrigger={handleDeactivateTrigger}
        onDeleteTrigger={handleDeleteTrigger}
      />
    </div>
  );
};

export default AutomationTab;
